import session from '@/shared/session'

const state = {
  items: [],
  loading: false
}

const getters = {
  getAllShortcuts: (state) => () => state.items,
  isLoading: (state) => () => state.loading
}

const actions = {
  async fetchShortcuts({ commit, dispatch }) {
    dispatch('loading/load', 'keyboardshortcuts', { root: true })
    commit('set_loading', true)
    try {
      const res = await session.get('/api/decursus/keyboard-shortcuts/')
      commit('set_shortcuts', res.data)
      return res.data
    } finally {
      commit('set_loading', false)
      dispatch('loading/end', 'keyboardshortcuts', { root: true })
    }
  },

  addShortcut({ commit, dispatch }, data) {
    dispatch('loading/load', 'keyboardshortcuts', { root: true })
    return session.post('/api/decursus/keyboard-shortcuts/', data)
      .then(res => {
        commit('add_shortcut', res.data)
        return res.data
      })
      .finally(() => dispatch('loading/end', 'keyboardshortcuts', { root: true }))
  },

  deleteShortcut({ commit, dispatch }, id) {
    dispatch('loading/load', 'keyboardshortcuts', { root: true })
    return session.delete(`/api/decursus/keyboard-shortcuts/${id}/`)
      .then(() => commit('remove_shortcut', id))
      .finally(() => dispatch('loading/end', 'keyboardshortcuts', { root: true }))
  },

  updateShortcut({ commit, dispatch }, { id, data }) {
    dispatch('loading/load', 'keyboardshortcuts', { root: true })
    return session.patch(`/api/decursus/keyboard-shortcuts/${id}/`, data)
      .then(res => {
        commit('update_shortcut', res.data)
        return res.data
      })
      .finally(() => dispatch('loading/end', 'keyboardshortcuts', { root: true }))
  }
}

const mutations = {
  set_shortcuts(state, items) {
    state.items = items || []
  },
  set_loading(state, val) {
    state.loading = !!val
  },
  add_shortcut(state, item) {
    state.items = [...state.items, item]
  },
  remove_shortcut(state, id) {
    state.items = state.items.filter(i => i.id !== id)
  },
  update_shortcut(state, item) {
    state.items = state.items.map(i => (i.id === item.id ? item : i))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
